<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="搜索关键字" name="keyword"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="产品分类"
                    name="product_type_name"
                    width="100"
                >
				</c-table-column>

                <c-table-column
                        label="产品图片"
                        name="product_image"
                        width="120"
                >
                    <template v-slot="{data}">
                        <c-image :src="data.product_image" size="60"></c-image>
                    </template>
                </c-table-column>

                <c-table-column
					label="产品名"
                    name="product_name"
                    width="200"
                >
				</c-table-column>

				<c-table-column
					label="产品英文名"
                    name="product_name_en"
                    width="200"
                >
				</c-table-column>

				<c-table-column
					label="产品英文名"
                    name="product_name_en"
                    width="200"
                >
				</c-table-column>

				<c-table-column
					label="产品号"
					name="product_number"
					width="150"
				></c-table-column>

				<c-table-column
					label="产品CAS号"
					name="product_cas_number"
					width="150"
				></c-table-column>

				<c-table-column
					label="MDL"
					name="mdl"
					width="150"
				></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="60"
                >
                    <template v-slot="row">
                        <c-table-button @click="navigateTo(`/website/material/detail/${row.data.id}`)">查看</c-table-button>
                    </template>
                </c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_material',
		
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/material/list',
					data
				});
			}
		}
	}
</script>